import { ASSETS } from "@/lib/assets";

const SCREENS = [
  { src: ASSETS.screenToday, label: "Today", caption: "Your day, gently prioritised" },
  { src: ASSETS.screenPantry, label: "Pantry", caption: "Scan once, organised forever" },
  { src: ASSETS.screenHome, label: "Home", caption: "A maintenance vault for your home" },
  { src: ASSETS.screenHousehold, label: "Household", caption: "Share tasks with the people you live with" },
];

export const Screens = () => (
  <section id="screens" className="py-24 lg:py-32">
    <div className="mx-auto max-w-6xl px-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--terracotta)]">
            Inside the app
          </p>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-[var(--ink)] sm:text-5xl">
            Designed to feel like home.
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-[var(--ink-soft)]">
          Soft colours, calm typography and zero clutter — because managing a
          household shouldn't feel like work.
        </p>
      </div>

      <div className="mt-14 grid grid-cols-2 gap-6 lg:grid-cols-4" data-testid="screens-grid">
        {SCREENS.map(({ src, label, caption }, i) => (
          <figure key={label} className={i % 2 === 1 ? "lg:translate-y-8" : ""}>
            <div className="overflow-hidden rounded-[1.8rem] border-[5px] border-[var(--ink)] bg-[var(--ink)] shadow-[0_24px_48px_-20px_rgba(46,42,36,0.4)] transition-transform duration-300 hover:-translate-y-1.5">
              <img src={src} alt={`Domaya ${label} screen`} className="block w-full object-cover" loading="lazy" />
            </div>
            <figcaption className="mt-4 px-1">
              <span className="text-sm font-semibold text-[var(--olive-deep)]">{label}</span>
              <p className="mt-0.5 text-xs text-[var(--ink-soft)]">{caption}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
